import request from "@/untils/request.js"

export const getClinicFeeManagementPage = (params) => {
    return request.get("/outpatient/cfeerecord/page", {params})
}

export const addClinicFeeManagement = (data) => {
    return request.post("/outpatient/cfeerecord", data)
}

export const editClinicFeeManagement = (data) => {
    return request.put("/outpatient/cfeerecord", data)
}

export const getClinicFeeManagementById = (id) => {
    return request.get(`/outpatient/cfeerecord/${id}`)
}

export const getClinicFeeManagementList = (params) => {
    return request.get('/outpatient/sostype/list',{params})
}

export const getClinicFeeChargeAgainst= (params) => {
    return request.get('/outpatient/cfeerecord/offset',{params})
}